import { Link } from 'react-router-dom';
import { stars } from '@/mocks/stars';

export default function StarHighlights() {
  const top = [...stars].sort((a, b) => b.heat - a.heat).slice(0, 4);

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              明星动态精选
            </h2>
            <p className="mt-2 text-sm text-foreground-500">最新明星资讯与作品动态一览</p>
          </div>
          <Link
            to="/stars"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            全部明星
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {top.map((star) => (
            <Link
              key={star.id}
              to={`/stars?star=${star.id}`}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <div className="h-16 w-16 shrink-0 overflow-hidden rounded-lg bg-background-200">
                <img
                  src={star.avatar}
                  alt={`${star.name} 头像`}
                  title={`${star.name} 明星动态`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600">
                    {star.name}
                  </h3>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-900">
                    {star.role}
                  </span>
                </div>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                  {star.news[0]}
                </p>
                <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-fire-line" />
                  热度 {star.heat}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}